import RequestInvoicingForm from './RequestInvoicingForm';
import { createCurrentUser } from '../../util/test-data';

const billing = {
  customerType: 'BUSINESS',
  legalName: 'Testi Oy',
  country: 'FI',
  postalCode: '00100',
  street: 'Testikatu 1',
  city: 'Helsinki',
  vatNumber: 'FI31503663',
  businessProofRef: null,
};
const base = {
  formId: 'RequestInvoicingFormExample',
  billing,
  currentUser: createCurrentUser('u1', { email: 'matti@testi.fi' }),
  onLookupCompany: () => Promise.resolve({ company: null, revenue: null }),
  onSubmit: () => Promise.resolve({ status: 'pending' }),
  onEditBilling: () => null,
};

export const Finland = { component: RequestInvoicingForm, props: base, group: 'payment methods' };

export const AfterLookup = {
  component: RequestInvoicingForm,
  props: {
    ...base,
    lookupResult: {
      company: {
        name: 'Testi Oy',
        businessId: '3150366-3',
        companyForm: 'Osakeyhtiö',
        address: { street: 'Testikatu 1', postalCode: '00100', city: 'Helsinki', country: 'FI' },
      },
      revenue: null,
    },
  },
  group: 'payment methods',
};

export const OtherCountry = {
  component: RequestInvoicingForm,
  props: {
    ...base,
    billing: {
      ...billing,
      legalName: 'Musterfirma GmbH',
      country: 'DE',
      city: 'Berlin',
      postalCode: '10115',
      street: 'Musterstraße 1',
      vatNumber: 'DE123456789',
      businessProofRef: 'HRB 12345',
    },
    onCancel: () => null,
  },
  group: 'payment methods',
};
